import { persistor } from '../../../utils/store';
import { reloadPage } from './reloadPage';
import {
  addToRecentList,
  readRecentList,
  recentAssumedStorageKey,
  writeRecentList,
} from './recentList';
import { AssumedUserRecord } from './assumeUserApi';

type RecentAssumed = { id: string; at: string };

export function rememberAssumedUser(csrUsername?: string | null, assumedUsername?: string | null): void {
  const key = recentAssumedStorageKey(csrUsername);
  if (!key || !assumedUsername) return;
  writeRecentList(
    key,
    addToRecentList(readRecentList<RecentAssumed>(key), {
      id: assumedUsername,
      at: new Date().toISOString(),
    }),
  );
}

type TrackAnalytics = (category: string, action: string, pathname?: string, username?: string) => void;

/** Reload once redux-persist has written the assume change, so the next page has it. */
function reloadAfterPersist(): void {
  persistor.flush().then(reloadPage);
}

/**
 * Shared assume finish: clear any previous assume payload, store the new
 * one, record the recent entry, then reload. Callers pass the bound
 * Redux actions (the header is a class and cannot use the hook).
 */
export function completeAssume({
  csrUsername,
  assumedUser,
  clearAssumeUser,
  applyAssumeUser,
  pathname,
}: {
  csrUsername?: string;
  assumedUser: AssumedUserRecord;
  clearAssumeUser?: () => void;
  applyAssumeUser: (user: AssumedUserRecord) => void;
  pathname?: string;
}): void {
  const track = (global as { trackAnalyticsEvent?: TrackAnalytics }).trackAnalyticsEvent;
  if (typeof track === 'function') {
    track('Assume User', 'Assume user', pathname, csrUsername);
  }
  if (clearAssumeUser) clearAssumeUser();
  applyAssumeUser(assumedUser);
  rememberAssumedUser(csrUsername, assumedUser && assumedUser.username);
  reloadAfterPersist();
}

export function releaseAssumeUser({ clearAssumeUser }: { clearAssumeUser: () => void }): void {
  clearAssumeUser();
  reloadAfterPersist();
}
